/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const Entitlement = core.serialization.object({
    key: core.serialization.string(),
    metadata: core.serialization.any(),
});
